import React from 'react';
import styled from 'styled-components';
import { FaQuoteRight } from 'react-icons/fa';
import Card from './Card';

interface TestimonialCardProps {
  quote: string;
  name: string;
  position: string;
  company: string;
  imageSrc: string;
}

const StyledCard = styled(Card)`
  position: relative;
  padding: ${({ theme }) => theme.space.xl};
  margin-top: ${({ theme }) => theme.space.xl};
`;

const QuoteIcon = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.space.md};
  right: ${({ theme }) => theme.space.md};
  color: ${({ theme }) => theme.colors.grey[200]};
  font-size: ${({ theme }) => theme.fontSizes['3xl']};
  opacity: 0.7;
`;

const QuoteText = styled.p`
  font-style: italic;
  margin-bottom: ${({ theme }) => theme.space.lg};
  color: ${({ theme }) => theme.colors.grey[700]};
  position: relative;
  z-index: 1;
`;

const ClientInfo = styled.div`
  display: flex;
  align-items: center;
`;

const ClientImage = styled.div<{ $imageSrc: string }>`
  width: 60px;
  height: 60px;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  background-image: url(${({ $imageSrc }) => $imageSrc});
  background-size: cover;
  background-position: center;
  margin-right: ${({ theme }) => theme.space.md};
  border: 2px solid ${({ theme }) => theme.colors.primary};
`;

const ClientDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const ClientName = styled.h4`
  margin-bottom: ${({ theme }) => theme.space.xs};
  font-size: ${({ theme }) => theme.fontSizes.md};
`;

const ClientPosition = styled.p`
  color: ${({ theme }) => theme.colors.grey[600]};
  margin-bottom: 0;
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  quote,
  name,
  position,
  company,
  imageSrc,
}) => {
  return (
    <StyledCard hoverEffect={false} elevation="medium">
      <QuoteIcon>
        <FaQuoteRight />
      </QuoteIcon>
      <QuoteText>"{quote}"</QuoteText>
      <ClientInfo>
        <ClientImage $imageSrc={imageSrc} />
        <ClientDetails>
          <ClientName>{name}</ClientName>
          <ClientPosition>
            {position}, {company}
          </ClientPosition>
        </ClientDetails>
      </ClientInfo>
    </StyledCard>
  );
};

export default TestimonialCard;
